import { Globals } from "../CoreApp/Globals";

export function handleGestureEnd(event) {
  Globals._gestureActive = false;
  Globals._gestureScaleFactor = 1;
  Globals._lastMultiTouchScale = 1;
  Globals._lastMultiTouchDim = null;
  event.preventDefault();
  event.stopPropagation();
}
